const Badge = ({ type, size, children }) => {
  const TYPE_COLOR = {
    PRIMARY: 'bg-gray-100 text-gray-800',
    SECONDARY: 'border border-gray-200 rounded bg-gray-50 text-gray-700',
    ALERT: 'bg-red-100 text-red-800',
    WARNING: 'bg-yellow-50 text-yellow-500',
    VALID: 'bg-green-100 text-green-800',
    APP: 'bg-[#FAF5FF] text-[#9333EA]',
    WEB: 'bg-yellow-50 text-yellow-600',
    INDEED: 'bg-blue-50 text-blue-600',
  };

  const SIZE = {
    SM: 'h-6 px-2',
    LG: 'py-2 px-3',
  };

  const tag_color = TYPE_COLOR[type || 'PRIMARY'];
  const size_className = SIZE[size || 'SM'];
  return (
    <>
      <div
        className={`${size_className} ft-sm rounded-md flex flex-row items-center justify-center gap-4 ${tag_color}`}
      >
        {children}
      </div>
    </>
  );
};

export default Badge;
